import React, { useCallback, useEffect, useReducer, useRef } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment-timezone";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import { useCookies } from "react-cookie";
import { searchClassicTicket } from "../../../controller/api/__classic__/ticket";
import { calculatePage } from "../../../helper/helper";

export const Context = React.createContext(null);

const getInitialCartIdFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get('search') || '';
};

const initialData = {
  filter: {
    numbers: '',
    cartId: getInitialCartIdFromUrl(),
    ticketId: '',
    status: '',
    fromDate: moment().startOf('day'),
    toDate: moment().endOf('day'),
    playerPhone: '',
    playerName: '',
    region: '',
    page: 0
  },
  data: {
    list: [],
    total: 0,
    totalPage: 0
  },
  loading: false,
  filterPressCount: 0,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        filter: {
          ...action.payload,
          page: 0
        },
        filterPressCount: state.filterPressCount + 1
      }
    case 'RESET_FILTER':
      return {
        ...state,
        filter: {
          numbers: '',
          cartId: '',
          ticketId: '',
          status: '',
          fromDate: moment().startOf('day'),
          toDate: moment().endOf('day'),
          playerPhone: '',
          playerName: '',
          region: '',
          page: 0
        },
        data: {
          list: [],
          total: 0,
          totalPage: 0
        },
        filterPressCount: 0
      }
    case 'UPDATE_DATA':
      return {
        ...state,
        data: {
          ...action.payload
        },
        loading: false
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload
      }
    case 'UPDATE_PAGE':
      return {
        ...state,
        filter: {
          ...state.filter,
          page: action.payload
        }
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  var [state, dispatch] = useReducer(reducer, initialData);

  const location = useLocation();

  const [cookies] = useCookies(['lottmekong'])

  const isFirstMount = useRef(true);
  const prevLocationSearch = useRef(location.search);

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }

    if (prevLocationSearch.current === location.search) {
      return;
    }
    prevLocationSearch.current = location.search;

    const searchParams = new URLSearchParams(location.search);
    const searchValue = searchParams.get('search') || '';

    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        ...state.filter,
        cartId: searchValue,
        page: 0,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getAllFunc = useCallback(async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const query = {
      numbers: state.filter.numbers,
      cartId: state.filter.cartId,
      ticketId: state.filter.ticketId,
      status: state.filter.status !== '' ? parseInt(state.filter.status) : undefined,
      fromDate: state.filter.fromDate ? moment(state.filter.fromDate).startOf('day').toISOString() : undefined,
      toDate: state.filter.toDate ? moment(state.filter.toDate).endOf('day').toISOString() : undefined,
      playerPhone: state.filter.playerPhone,
      playerName: state.filter.playerName,
      region: state.filter.region || undefined,
      loadDefault: true, // Load 100 item đầu tiên mặc định
    };

    try {
      const response = await searchClassicTicket(
        cookies.lottmekong,
        query,
        state.filter.page,
      );

      if (response) {
        dispatch({
          type: "UPDATE_DATA",
          payload: {
            list: response.data,
            total: response.total,
            totalPage: calculatePage(response.total),
          },
        });
      } else {
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (err) {
      console.log("classic search getAllFunc error", err);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  }, [cookies.lottmekong, state.filter])

  useEffect(() => {

    getAllFunc()
  }, [getAllFunc, state.filterPressCount, state.filter.page])

  useEffect(() => {
    document.title = "Tra cứu"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>

      <FilterForm />

      <Table />
    </Context.Provider>
  );
};
